const types = {
    info: {
        name: 'Info'
    },
    success: {
        name: 'Success'
    },
    warning: {
        name: 'Warning'
    }
};

export default types;